/* global foodbox */

import User from './state/User'

import {
    STATE_BEFORE_UPDATE,
    STATE_AFTER_UPDATE,
    STATE_BACK,
    STATE_FOWARD,
    STATE_RESET,
    STATE_LOAD,
} from './Paramaters';


export default class State {

    constructor(props) {
        this._data = {}
    }

    /** @return {User} */
    get user() {
        return this._data.user
    }

    /** @param {User} value*/
    set user(value) {
        this._data.user = value
    }


}

/** @type {State} */
export const state = new State();
